import { React, useState, useEffect, useCallback } from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { styled } from '@mui/material/styles';
import { Helmet } from 'react-helmet';
import Carousel from 'react-material-ui-carousel';
import Image from 'material-ui-image';
import AudioPlayer from 'material-ui-audio-player';
import { isUndefined } from 'lodash';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';

import { METADATA } from '../../constants';
import ButtonAppBar from './ButtonAppBar';
import Footer from '../../components/HomeComponents/Footer';
import instoremusic1 from '../../assets/images/instoremusic1.jpg';
import instoremusic2 from '../../assets/images/instoremusic2.jpg';
import instoremusic3 from '../../assets/images/instoremusic3.jpg';

import { stripeService } from '../../services';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // background: '#cc95c0', /* fallback for old browsers */
    // background: '-webkit-linear-gradient(to left, #cc95c0, #dbd4b4, #7aa1d2)', /* Chrome 10-25, Safari 5.1-6 */
    background: 'linear-gradient(to right, #5680E9, #84CEEB, #5AB9EA, #C1C8E4, #8860D0)' /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  },
  firstSection: {
    backgroundColor: '#E27D60',
    [theme.breakpoints.up('lg')]: {
      padding: '0px 340px'
    },
    [theme.breakpoints.down('lg')]: {
      padding: '0px'
    },
    [theme.breakpoints.down('sm')]: {
      order: 2
    }
  },
  firstSectionTextContent: {
    [theme.breakpoints.down('sm')]: {
      order: 2
    }
  },
  secondSection: {
    backgroundColor: '#E27D60',
    [theme.breakpoints.up('lg')]: {
      padding: '0px 340px',
      height: '608px'
    },
    [theme.breakpoints.down('lg')]: {
      padding: '0px',
      height: '608px'
    },
    [theme.breakpoints.down('sm')]: {
      height: 'auto'
    }
  },
  thirdSection: {
    backgroundColor: '#E27D60',
    // [theme.breakpoints.up('lg')]: {
    //   padding: '0px 340px'
    // },
    // [theme.breakpoints.down('lg')]: {
    //   padding: '0px'
    // }
    [theme.breakpoints.up('lg')]: {
      padding: '0px 340px',
      height: '608px'
    },
    [theme.breakpoints.down('lg')]: {
      padding: '0px',
      height: '608px'
    },
    [theme.breakpoints.down('sm')]: {
      height: 'auto'
    }
  },
  fourthSection: {
    backgroundColor: '#E27D60',
    [theme.breakpoints.up('lg')]: {
      padding: '50px 340px'
    },
    [theme.breakpoints.down('lg')]: {
      padding: '50px 40px'
    }
  },
  carouselSection: {
    backgroundColor: '#E27D60',
    display: 'flex',
    justifyContent: 'center'
  },
  carouselRoot: {
    width: '60%',
    padding: '50px',

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  firstSectionImage: {
    [theme.breakpoints.up('md')]: {
      height: '100% !important'
    },
    [theme.breakpoints.down('sm')]: {
      height: 'auto !important',
      position: 'relative !important'
    }
  },
  secondSectionImage: {
    [theme.breakpoints.down('sm')]: {
      padding: '25px 50px'
    }
  },
  thirdSectionImage: {
    [theme.breakpoints.down('sm')]: {
      padding: '25px 50px'
    }
  },
  firstSectionImageContainer: {
    [theme.breakpoints.up('md')]: {
      height: '100%'
    },
    [theme.breakpoints.down('sm')]: {
      height: 'auto'
    }
  },
  secondSectionImageContainer: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: '65px !important'
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '16px !important',
      order: 2
    }
  },
  secondTextContent: {
    fontSize: '1.5rem',
    margin: '24px 0px',
    color: '#FFF',
    fontWeight: '400',
    fontFamily: 'Epidemic, sans-serif',

    [theme.breakpoints.down('sm')]: {
      margin: '50px 0px',
    }
  },
  thirdSectionImageContainer: {
    [theme.breakpoints.up('md')]: {
      paddingRight: '65px !important'
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: '16px !important'
    }
  },
  thirdSectionTextContent: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: '50px !important',
      paddingBottom: '50px'
    }
  },
  fourthSectionGridItemOne: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'center'
    }
  },
  fourthSectionGridItemTwo: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'center'
    }
  },
  listItem: {
    fontSize: '1rem',
    lineHeight: '24px',
    fontWeight: '500',
    fontFamily: 'Epidemic, sans-serif',
    color: '#767676',
    margin: '0px'
  },
  audioPlayer: {
    zIndex: '1000 !important',
    position: 'fixed',
    display: 'flex',
    bottom: 0
  },
  audioPlayerActionIcon: {
    display: 'flex !important',
    position: 'absolute',
    color: '#FFF',
    zIndex: 10,
    width: '95% !important',
    height: '10% !important',
    justifyContent: 'center',
    margin: '35% 0px'
  }
}));

const muiTheme = createMuiTheme({});

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: '32px',
  textAlign: 'left',
  backgroundColor: '#333333',
  color: '#FFF'
}));


export default function CommercialSubscription() {
  const classes = useStyles();

  const [isShowMusicPlayer, setIsShowMusicPlayer] = useState(false);
  const [isMusicPlayerPlay, setIsMusicPlayerPlay] = useState(false);
  const [audioSource, setAudioSource]= useState(undefined);
  const [checkoutSessionUrl1, setCheckoutSessionUrl1] = useState(undefined);
  const [checkoutSessionUrl2, setCheckoutSessionUrl2] = useState(undefined);

  const items = [
    {
      thumbnail: instoremusic1,
      audioLink: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3'
    },
    {
      thumbnail: instoremusic2,
      audioLink: 'https://www.learningcontainer.com/wp-content/uploads/2020/02/Kalimba.mp3'
    },
    {
      thumbnail: instoremusic3,
      audioLink: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3'
    }
  ]

  const handleAudioTrackClick = (event) => {
    const elementId = event.currentTarget.id;
    setIsShowMusicPlayer(true);
    setIsMusicPlayerPlay(!isMusicPlayerPlay);
    setAudioSource(event.currentTarget.dataset.link);

    if (elementId === 'pause-icon') {
      handlePauseTrack();
    } else if (elementId === 'play-icon') {
      handlePlayTrack();
    }
  }

  const handleCarouselOnChange = () => {
    setIsMusicPlayerPlay(false);
  }

  const handlePauseTrack = () => {
    const audio = document.getElementsByTagName("audio")[0];
    audio.pause();
  }

  const handlePlayTrack = () => {
    const audio = document.getElementsByTagName("audio")[0];

    if (audio) {
      audio.play();
    }
  }

  const createCheckoutSessionStripePrice1 = useCallback(async (value) => {
    const priceId = 'price_1JiFeqDWQef9vrj3AtW6sJos';

    const payload = {
      price: priceId
    }

    const res = await stripeService.createCheckoutSession(payload);

    if (!isUndefined(res)) {
      const url = JSON.parse(res).url;
      setCheckoutSessionUrl1(url);
    }
  }, []);

  const createCheckoutSessionStripePrice2 = useCallback(async (value) => {
    const priceId = 'price_1JiFfrDWQef9vrj3D5RE2EVR';

    const payload = {
      price: priceId
    }

    const res = await stripeService.createCheckoutSession(payload);

    if (!isUndefined(res)) {
      const url = JSON.parse(res).url;
      setCheckoutSessionUrl2(url);
    }
  }, []);

  useEffect(() => {
    createCheckoutSessionStripePrice1();
  }, [createCheckoutSessionStripePrice1]);

  useEffect(() => {
    createCheckoutSessionStripePrice2();
  }, [createCheckoutSessionStripePrice2]);

  const CarouselItem = (props) => {
    const classes = useStyles();
  
    return (
      <Paper>
        <div>
          {isMusicPlayerPlay ? (
            <div id="pause-icon" data-link={props.audioLink} onClick={handleAudioTrackClick}>
              <PauseCircleOutlineIcon className={classes.audioPlayerActionIcon} />
            </div>
          ) : (
            <div id="play-icon" data-link={props.audioLink} onClick={handleAudioTrackClick}>
              <PlayCircleOutlineIcon className={classes.audioPlayerActionIcon} />
            </div>
          )}
          <Image cover='true' color='#0F0F0F' src={props.item} />
        </div>
      </Paper>
    )
  }

  return (
    <div className={classes.root}>
      <Helmet>
        <meta name="description" content={METADATA.COMMERCIALSUBSCRIPTION.description} />
        <title>{METADATA.COMMERCIALSUBSCRIPTION.title}</title>
      </Helmet>
      <ButtonAppBar />
      <Box sx={{ flexGrow: 1, height: '100%' }}>
        <Grid className={classes.firstSection} sx={{ height: '900px' }} container spacing={2}>
          <Grid
            className={classes.firstSectionTextContent}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              paddingLeft: '64px !important',
              paddingRight: '30px !important'
            }}
            p={0}
            item
            xs={12}
            sm={12}
            md={5}
          >
            <div>
              <h1
                style={{
                  fontSize: '64px',
                  color: '#FFF',
                  fontFamily: 'Epidemic, sans-serif',
                  fontWeight: '600',
                  lineHeight: '4.5rem',
                  letterSpacing: '-0.6px'
                }}
              >Great music, safe to use</h1>
              <p style={{ fontSize: '1.5rem', margin: '24px 0px', color: '#FFF', fontWeight: '400', fontFamily: 'Epidemic, sans-serif', }}>Commercial Plan</p>
              <p style={{ fontSize: '1.5rem', margin: '24px 0px', color: '#FFF', fontWeight: '400', fontFamily: 'Epidemic, sans-serif', }}>Are you a freelancer, production company or brand in need of music for 
                video? Our license gives you professionally composed music to use in your 
                own or clients’ content, without ever getting copyright strikes.
              </p>
            </div>
          </Grid>
          <Grid className={classes.firstSectionImageContainer} sx={{ paddingRight: '0px !important' }} p={0} item xs={12} sm={12} md={7}>
            <Image className={classes.firstSectionImage} color='#0F0F0F' style={{ height: 'inherit', paddingTop: '0px' }} cover='true' src={instoremusic1} />
          </Grid>
        </Grid>

        <Grid className={classes.carouselSection} container spacing={1}>
          <Carousel onChange={handleCarouselOnChange} interval={80000} className={classes.carouselRoot} style={{ width: '100%' }}>
            {
              items.map( (item, i) => <CarouselItem key={i} audioLink={item.audioLink} item={item.thumbnail} /> )
            }
          </Carousel>
        </Grid>

        <Grid className={classes.secondSection} container spacing={2}>
          <Grid className={classes.secondSectionImageContainer} sx={{ paddingRight: '0px !important', height: '528px !important' }} p={0} item xs={12} sm={12} md={5}>
            <Image className={classes.secondSectionImage} color='#0F0F0F' style={{ height: 'inherit', paddingTop: '0px' }} cover='true' src={instoremusic2} />
          </Grid>
          <Grid
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              paddingLeft: '64px !important',
              paddingRight: '30px !important',
              height: 'inherit'
            }}
            p={0}
            item
            xs={12}
            sm={12}
            md={7}
          >
            <div>
              <p className={classes.secondTextContent}>Our music is made by musicians and studio professionals who live and breathe music. </p>
            </div>
          </Grid>
        </Grid>
        <Grid className={classes.thirdSection} container spacing={2}>
          <Grid
            className={classes.thirdSectionTextContent}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              paddingLeft: '64px !important',
              paddingRight: '30px !important',
              height: 'inherit'
            }}
            p={0}
            item
            xs={12}
            sm={12}
            md={7}
          >
            <div>
              <h1
                style={{
                  fontSize: '64px',
                  color: '#FFF',
                  fontFamily: 'Epidemic, sans-serif',
                  fontWeight: '600',
                  lineHeight: '4.5rem',
                  letterSpacing: '-0.6px'
                }}
              >Always Included</h1>
              <p style={{ fontSize: '1.5rem', margin: '24px 0px', color: '#FFF', fontWeight: '400', fontFamily: 'Epidemic, sans-serif', }}>35,000 tracks</p>
              <p style={{ fontSize: '1.5rem', margin: '24px 0px', color: '#FFF', fontWeight: '400', fontFamily: 'Epidemic, sans-serif', }}>90,000 sound effects</p>
              <p style={{ fontSize: '1.5rem', margin: '24px 0px', color: '#FFF', fontWeight: '400', fontFamily: 'Epidemic, sans-serif', }}>Unlimited downloads & use</p>
              <p style={{ fontSize: '1.5rem', margin: '24px 0px', color: '#FFF', fontWeight: '400', fontFamily: 'Epidemic, sans-serif', }}>All rights covered</p>
              <p style={{ fontSize: '1.5rem', margin: '24px 0px', color: '#FFF', fontWeight: '400', fontFamily: 'Epidemic, sans-serif', }}>No royalty fees</p>
              <p style={{ fontSize: '1.5rem', margin: '24px 0px', color: '#FFF', fontWeight: '400', fontFamily: 'Epidemic, sans-serif', }}>30-day free trial</p>
              <p style={{ fontSize: '1.5rem', margin: '24px 0px', color: '#FFF', fontWeight: '400', fontFamily: 'Epidemic, sans-serif', }}>Cancel anytime</p>
            </div>
          </Grid>
          <Grid className={classes.thirdSectionImageContainer} sx={{ height: '528px !important' }} p={0} item xs={12} sm={12} md={5}>
            <Image className={classes.thirdSectionImage} color='#0F0F0F' style={{ height: 'inherit', paddingTop: '0px' }} cover='true' src={instoremusic3} />
          </Grid>
        </Grid>
        <Grid className={classes.fourthSection} container spacing={2}>
          <Grid className={classes.fourthSectionGridItemOne} item xs={12} sm={12} md={6}>
            <Item>
              <div>
                <h2
                  style={{
                    fontSize: '2rem',
                    color: '#FFF',
                    fontFamily: 'Epidemic, sans-serif',
                    fontWeight: '500',
                    lineHeight: '2.5rem',
                    letterSpacing: '-0.6px'
                  }}
                >Monthly Plan</h2>
                <p style={{ fontSize: '1.5rem', margin: '24px 0px', color: '#FFF', fontWeight: '400', fontFamily: 'Epidemic, sans-serif', }}>You're creating videos or podcasts for your own use.</p>
                <ul>
                  <li className={classes.listItem}>Covered for YouTube, Facebook, Instagram, TikTok, Twitch and podcasts</li>
                  <li className={classes.listItem}>Add one channel per platform</li>
                  <li className={classes.listItem}>You can have unlimited followers and views</li>
                  <li className={classes.listItem}>Includes monetization</li>
                </ul>
                <div style={{ padding: '40px 0px 24px 0px' }}>
                  <h1
                    style={{
                      fontSize: '2.5rem',
                      color: '#FFF',
                      fontFamily: 'Epidemic, sans-serif',
                      fontWeight: '600',
                      lineHeight: '3rem',
                      letterSpacing: '-0.02px'
                    }}
                  >US$12/month*</h1>
                  <ul>
                    <li className={classes.listItem}>When you pay US$144/year upfront for one year. Otherwise US$15 monthly.</li>
                  </ul>
                </div>
                <a href={checkoutSessionUrl1 ? checkoutSessionUrl1 : '#'}>
                  <Button variant="contained">Start free trial</Button>
                </a>
              </div>
            </Item>
          </Grid>
          <Grid className={classes.fourthSectionGridItemTwo} item xs={12} sm={12} md={6}>
            <Item>
              <div>
                  <h2
                    style={{
                      fontSize: '2rem',
                      color: '#FFF',
                      fontFamily: 'Epidemic, sans-serif',
                      fontWeight: '500',
                      lineHeight: '2.5rem',
                      letterSpacing: '-0.6px'
                    }}
                  >Yearly Plan</h2>
                  <p style={{ fontSize: '1.5rem', margin: '24px 0px', color: '#FFF', fontWeight: '400', fontFamily: 'Epidemic, sans-serif', }}>You're creating videos or podcasts for your own use.</p>
                  <ul>
                    <li className={classes.listItem}>Covered for YouTube, Facebook, Instagram, TikTok, Twitch and podcasts</li>
                    <li className={classes.listItem}>Add one channel per platform</li>
                    <li className={classes.listItem}>You can have unlimited followers and views</li>
                    <li className={classes.listItem}>Includes monetization</li>
                  </ul>
                  <div style={{ padding: '40px 0px 24px 0px' }}>
                    <h1
                      style={{
                        fontSize: '2.5rem',
                        color: '#FFF',
                        fontFamily: 'Epidemic, sans-serif',
                        fontWeight: '600',
                        lineHeight: '3rem',
                        letterSpacing: '-0.02px'
                      }}
                    >US$12/year*</h1>
                    <ul>
                      <li className={classes.listItem}>When you pay US$144/year upfront for one year. Otherwise US$15 monthly.</li>
                    </ul>
                  </div>
                  <a href={checkoutSessionUrl2 ? checkoutSessionUrl2 : '#'}>
                    <Button variant="contained">Start free trial</Button>
                  </a>
                </div>
            </Item>
          </Grid>
        </Grid>
      </Box>
      {isShowMusicPlayer ? (
        <Box sx={{ position: 'fixed', width: '100%', bottom: 0, display: 'flex', justifyContent: 'center' }}>
          <ThemeProvider theme={muiTheme}>
            <AudioPlayer autoplay={true} src={audioSource} displayCloseButton={true} />
          </ThemeProvider>
        </Box>
      ) : ''}
      <Footer />
    </div>
  )
}